import { Reducer } from 'redux';
import { AppOrganization, AppOrganizationState, AppOrganizationTypes } from './types';

const INITIAL_STATE: AppOrganizationState = {
    data: {} as AppOrganization,
    loading: false,
    hasError: false,
    success: false,
};

const reducer: Reducer<AppOrganizationState> = (state: AppOrganizationState = INITIAL_STATE, action) => {
    switch (action.type) {
        case AppOrganizationTypes.GET_APP_ORGANIZATION_REQUEST:
            return { ...INITIAL_STATE, loading: true };
        case AppOrganizationTypes.GET_APP_ORGANIZATION_SUCCESS:
            return {
                ...INITIAL_STATE,
                data: {
                    ...action.payload.data,
                    isWhiteLabel: !!action.payload.data.dynamicAttributes.whiteLabel,
                    isTotvs: !!action.payload.data.dynamicAttributes.totvs,
                },
            };
        case AppOrganizationTypes.GET_APP_ORGANIZATION_FAILURE:
            return { ...INITIAL_STATE, hasError: true };
        case AppOrganizationTypes.SET_CONFIG_REQUEST:
            return { ...state, loading: true, success: false };
        case AppOrganizationTypes.SET_CONFIG_SUCCESS:
            return { ...state, loading: false, success: true };
        case AppOrganizationTypes.SET_CONFIG_FAILURE:
            return { ...state, loading: false, success: false };
        case AppOrganizationTypes.GET_PASSWORD_RULES_REQUEST:
            return { ...state, hasError: false, loading: true };
        case AppOrganizationTypes.GET_PASSWORD_RULES_SUCCESS:
            return { ...state, hasError: false, loading: false, success: true, data: { ...state.data, passwordRules: action.payload } };
        case AppOrganizationTypes.GET_ORGANIZATION_STATS_REQUEST:
            return { ...state, loading: true, success: false, hasError: false };
        case AppOrganizationTypes.GET_ORGANIZATION_STATS_SUCCESS:
            return { ...state, loading: false, success: true, hasError: false, data: { ...state.data, stats: action.payload } };
        case AppOrganizationTypes.GET_ORGANIZATION_STATS_FAILURE:
            return { ...state, loading: false, success: false, hasError: true };
        default:
            return state;
    }
};

export default reducer;
